// extracted by mini-css-extract-plugin
export default {"FildeModal":"FildeModal_FildeModal__EBHRa","title":"FildeModal_title__rqgwz","text":"FildeModal_text__dgQe2","btnred":"FildeModal_btnred__IfJaE","galka":"FildeModal_galka__e1vzj"};